

<!-- <p-menu [model]="menuItems" [style]="{'width': '100%', 'height': '100%'}"></p-menu> -->


<p-menubar [model]="menuItems" styleClass="sidebarBody"></p-menubar>